import React, { useState } from "react";
import { Typography, TextField } from "@mui/material";

export default function EditableText({ value, onChange, disabled = false, variant = undefined, sx = undefined, component = undefined }) {
    const [editing, setEditing] = useState(false);
    const [text, setText] = useState(value);
    const [lastValue, setLastValue] = useState(value);

    // Follow changes made elsewhere (e.g. a series rename). Only react when the prop itself
    // changes, never mid-edit, so a title just typed can't flip back to the old one while saving.
    if (value !== lastValue) {
        setLastValue(value);
        if (!editing) setText(value);
    }

    const handleBlur = () => {
        setEditing(false);
        onChange?.(text);
    };

    return (
        <>
            {editing && !disabled ? (
                <TextField
                    value={text}
                    autoFocus
                    variant="standard"
                    onChange={(e) => setText(e.target.value)}
                    onBlur={handleBlur}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") e.currentTarget.blur();
                    }}
                    sx={{ minWidth: 120 }}
                />
            ) : (
                <Typography
                    component={component}
                    variant={variant}
                    onDoubleClick={() => !disabled && setEditing(true)}
                    sx={[
                        { cursor: disabled ? "default" : "pointer", overflowWrap: "anywhere" },
                        ...(Array.isArray(sx) ? sx : [sx]),
                    ]}
                >
                    {text}
                </Typography>
            )}
        </>
    );
}